/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Block count",
  "description": "Shows the total number of blocks in a project in the editor menu bar with detailed complexity analysis. Click the block count to see detailed project metrics including nesting depth, script complexity, and block type distribution. Previously part of \"sprite and script count\".",
  "tags": [],
  "credits": [
    {
      "name": "TheColaber",
      "link": "https://scratch.mit.edu/users/TheColaber/"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "blockcount.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "settings": [
    {
      "name": "Show complexity score in menu bar",
      "id": "show_complexity_score",
      "type": "boolean",
      "default": false
    },
    {
      "name": "Show costume count in menu bar",
      "id": "show_costume_count",
      "type": "boolean",
      "default": false
    },
    {
      "name": "Show sound count in menu bar",
      "id": "show_sound_count",
      "type": "boolean",
      "default": false
    },
    {
      "name": "Hide block count in menu bar",
      "id": "hide_block_count",
      "type": "boolean",
      "default": false
    }
  ],
  "enabledByDefault": true
};
export default manifest;
